/* Transition entre pages (Chrome 126+, Safari 18.2+, ignoree ailleurs) : la
   fiche produit nomme sa premiere image « visuel-fiche » (vd-motion.css). Au
   depart d'une navigation vers une fiche, la canette cliquee -- carte du mur
   ou canette de l'ouverture -- recoit le meme nom, et elle seule : un nom en
   double sur la page ferait avorter toute la transition. La canette vole
   ainsi de sa carte jusqu'a sa place sur la fiche. */
(function () {
  function chemin(url) {
    try {
      return new URL(url, window.location.href).pathname.replace(/\/$/, '');
    } catch (erreur) {
      return '';
    }
  }

  function canettePour(destination) {
    var ouverture = document.querySelector('[data-vd-ouverture] .ouverture__parfum:not([hidden]) .ouverture__lien');
    if (ouverture && chemin(ouverture.href) === destination) {
      return document.querySelector('[data-vd-ouverture] .ouverture__canette');
    }
    var liens = document.querySelectorAll('.carte-produit__lien');
    for (var i = 0; i < liens.length; i++) {
      if (chemin(liens[i].href) === destination) {
        return liens[i].closest('.carte-produit').querySelector('.carte-produit__image');
      }
    }
    return null;
  }

  window.addEventListener('pageswap', function (evenement) {
    if (!evenement.viewTransition || !evenement.activation || !evenement.activation.entry) return;
    var destination = chemin(evenement.activation.entry.url);
    if (destination.indexOf('/products/') === -1) return;
    var canette = canettePour(destination);
    if (!canette) return;
    canette.style.viewTransitionName = 'visuel-fiche';
    evenement.viewTransition.finished.then(function () {
      canette.style.viewTransitionName = '';
    });
  });
})();
